import React from 'react';
import { Bar } from './SkeletonBar';

// Skeleton for the task market — mirrors the real layout (header, banner,
// goal strip, task rows) so content lands in place instead of popping in.
const TaskFeedSkeleton = () => (
  <div className="min-h-screen bg-canvas pb-24">
    <div className="bg-white">
      <div className="max-w-md mx-auto px-4 pt-4 pb-2">
        <div className="flex items-center justify-between">
          <Bar className="h-5 w-24" />
          <div className="flex flex-col items-end gap-2">
            <Bar className="h-2.5 w-10" />
            <Bar className="h-4 w-16" />
          </div>
        </div>
        <div className="mt-4 flex gap-5">
          <Bar className="h-3.5 w-9" />
          <Bar className="h-3.5 w-16" />
          <Bar className="h-3.5 w-11" />
          <Bar className="h-3.5 w-14" />
          <Bar className="h-3.5 w-14" />
        </div>
      </div>
    </div>

    <div className="max-w-md mx-auto">
      <span className="relative block h-[132px] overflow-hidden bg-black/[0.05]">
        <span className="animate-shimmer absolute inset-0 bg-gradient-to-r from-transparent via-white/70 to-transparent" />
      </span>
    </div>

    <div className="max-w-md mx-auto mt-2 border-y border-black/[0.05] bg-white px-4 py-3">
      <div className="flex items-center justify-between">
        <Bar className="h-3.5 w-16" />
        <Bar className="h-3.5 w-12" />
      </div>
      <Bar className="mt-3 h-1 w-full rounded-[2px]" />
    </div>

    <div className="max-w-md mx-auto mt-5 flex items-center justify-between px-4">
      <Bar className="h-4 w-20" />
      <Bar className="h-3 w-28" />
    </div>
    <div className="max-w-md mx-auto mt-2.5 divide-y divide-black/[0.05] border-y border-black/[0.05] bg-white">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-3">
          <Bar className="h-14 w-14 shrink-0 rounded-lg" />
          <div className="flex-1">
            <Bar className="h-3.5 w-3/4" />
            <Bar className="mt-2 h-3 w-1/2" />
          </div>
          <Bar className="h-7 w-14 shrink-0 rounded-lg" />
        </div>
      ))}
    </div>
  </div>
);

export default TaskFeedSkeleton;
